(function () {
  'use strict';

  angular
    .module('events.vehicles.deposits.list')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('events.vehicles.deposits.list', {
        url: '?q&p',
        params: {
          q: {
            value: '',
            squash: true
          },
          p: {
            value: '1',
            squash: true
          }
        },
        reloadOnSearch: false,
        templateUrl: 'events/vehicles/deposits/list/list.tpl.html',
        controller: 'DepositsListCtrl',
        controllerAs: 'vm'
      })
    ;
  }
}());
